var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c(_vm.icon,{tag:"component",class:("svg-icon svg-icon--size-" + _vm.size)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }